import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader, Section } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        
        <PageHeader {...page} subheading="Collect contact information after a tenant has indicated that they'd like to cancel their reservation, rental, and/or account." >Cancel</PageHeader> 

        <SwitchRow {...page}  keyName= {LocationVarKey.HasProfileSettingCancelCollectProfile} label="Collect Profile" />
        <Section {...page} hideIf= {IS_NOT_EQUAL(LocationVarKey.HasProfileSettingCancelCollectProfile, "1")}>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ProfileSettingCancelMessage}
        />
        <DropdownRow {...page}  
        marginTop
        label=" Collection Method"
        keyName= {LocationVarKey.ProfileSettingCancelCollectionMethod}
        options={[
            {
                label:"Conversational",
                value:"Conversational"
            },
            {
                label:"Info Collect Card",
                value:"Card"
            }
        ]} />
        <DropdownRow {...page}  
        marginTop
        label=" Preferred Contact Method"
        keyName= {LocationVarKey.ProfileSettingCancelContactMethod}
        options={[
            {
                label:"Phone Number",
                value:"Phone"
            },
            {
                label:"Email",
                value:"Email"
            }
        ]} />
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingCancelWantShortProfile}  label="Short Profile" />
        <Indent {...page} >
            <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingCancelWantSecondaryOptional} hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingCancelWantShortProfile,"1")} label="Make Secondary Contact Method Optional" />
        </Indent>
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingCancelWantConfirmProfile} label="Confirm Profile" />
        </Section>


        



    </>
}